import React from 'react';
import Button from '@material-ui/core/Button';
// import {withStyles} from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import 'ol/ol.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import ImageLayer from 'ol/layer/Image';
// import Image from 'ol/layer/Image';
import OSM from 'ol/source/OSM';
import BingMaps from 'ol/source/BingMaps';
// import TileWMS from 'ol/source/TileWMS';
import ImageWMS from 'ol/source/ImageWMS';

export default class MyMap extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      center: [
        315, 22
      ],
      zoom: 3,
      layers: []
      // center: [-78.97, -3.66],
      // zoom: 11
    };

    this.map = new Map({
      target: null,
      layers: [// new TileLayer({source: new OSM()}),
        new TileLayer({
          source: new BingMaps({key: "AoJKrJV7zsLD8iLKa_mQ3eGS4vWPrz_neZMY9SYxEDMoWuSsUxLsrOukhabBqdPA", imagerySet: "AerialWithLabels"})
        })],
      view: new View({projection: 'EPSG:4326', center: this.state.center, zoom: this.state.zoom})
    });
  }

  updateMap() {
    this.map.getView().setCenter(this.state.center);
    this.map.getView().setZoom(this.state.zoom);
  }

  componentDidMount() {
    this.map.setTarget("map");

    // Listen to map changes
    this.map.on("moveend", () => {
      let center = this.map.getView().getCenter();
      let zoom = this.map.getView().getZoom();
      this.setState({center, zoom});
    });

    this.updateMap(); // Update map on did mount?
  }

  componentDidUpdate() {
    this.updateMap();
  }

  createMap() {
    this.map = new Map({
      target: 'map',
      layers: [new TileLayer({source: new OSM()})],
      view: new View({
        center: [
          0, 0
        ],
        zoom: 2
      })
    });
  }

  addLayer() {
    // OpenLayers Source Object
    let GeoServerURL = 'http://localhost:9085';
    let workspace = 'test';
    let layer = {
      'value': '4LFTX', //'bogota',
      'label': '4LFTX' //'bogota'
    };

    let wmsSource = new ImageWMS({
      ratio: 1,
      url: GeoServerURL + '/geoserver/wms',
      params: {
        'LAYERS': workspace + ':' + layer.value,
        'STYLES': workspace + ':' + layer.value
      },
      serverType: 'geoserver'
    });

    let wmsLayer = new ImageLayer({source: wmsSource, opacity: 0.5});

    wmsLayer.setVisible(true); // Set visible to false
    wmsLayer.set('wms', true); // Set wms to true
    wmsLayer.set('name', layer.label); // Set layer name
    wmsLayer.set('value', layer.value); // Set the layer value (used for info button)
    wmsLayer.set('resolution', ''); // Set the resolution to nothing for now
    this.map.addLayer(wmsLayer); // Add the layer to the map

    this.setState(prevState => ({
      layers: prevState.layers.concat(layer.value)
    }))

    console.log(this.map);
    console.log(this.map.getLayers());
  }

  // Remove layer from the map
  removeLayers() {
    this.map.getLayers().getArray().filter(mapLayer => mapLayer.get('name')).forEach(mapLayer => this.map.removeLayer(mapLayer));
    this.setState({layers: []});

  }

  setTarget() {
    this.map.setTarget("map");
  }

  listLayers() {
    return this.state.layers.map(layer => <div>{layer}</div>)
  }

  createLayerSwitches() {
    return this.state.layers.map(layer => <FormControlLabel control={<Switch value = {
        layer
      }
      color = 'primary' > </Switch>} label={layer}>{layer}</FormControlLabel>)
  }

  render() {
    return (<div className='mapContainer'>

      <div id="map">
        <div className='mapButtons'>
          <Button variant="contained" onClick={() => this.addLayer()}>Add Layer</Button>{" "}
          <Button variant="contained" onClick={() => this.removeLayers()}>Remove Layers</Button>
          <div className='layerBtnContainer'>
              <FormGroup>{this.createLayerSwitches()}</FormGroup>
          </div>
        </div>
      </div>
    </div>);
  }
}
